<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Analise de NPS'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">CompanyID</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="company"
                             name="company">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Média abaixo de</label>
                      <input v-model="dataSearch.lessThan" v-mask="'###'" type="text" class="form-control" id="lessThan"
                             name="lessThan" placeholder="Ex: 03">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Média acima de</label>
                      <input v-model="dataSearch.averangeUpTo" v-mask="'###'" type="text" class="form-control"
                             id="averangeUpTo" name="averangeUpTo" placeholder="Ex: 03">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>npsStage</label>
                      <select v-model="dataSearch.npsStage">
                        <option value="1">1 - Qual sua nota para a marqponto ate o momento?</option>
                        <option value="2">2 - Qual é a probabilidade de você recomendar a marqponto?</option>
                        <option value="3">3 - Qual sua nota para a marqponto depois desses meses de uso?</option>
                        <option value="4">4 - Qual é a probabilidade de você recomendar a MarQPonto a uma empresa de um
                          amigo(a)?
                        </option>
                        <option value="5">5 - Qual é a probabilidade de você recomendar a MarQPonto a uma empresa de um
                          amigo(a)?
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Empresas Desativadas?</label>
                      <select v-model="dataSearch.companyDesactived">
                        <option value="0">Não</option>
                        <option value="1">Sim</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button v-on:click="searchNps()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loading && (dataNps !== '' && !dataNps.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <div v-if="!loading && dataNps.length" class="col-xs-12 col-sm-12 col-md-12 padding-null">
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL DETRATOR <span>{{ totalDefractors }}</span></p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL NEUTRO <span>{{ totalNeutral }}</span></p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL PROMOTOR <span>{{ totalPromoters }}</span></p>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div v-if="!loading && dataNps.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">

                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de nps ({{ qtdTotal }})</span>
                    <span class="media-nps">Média de NPS: <span>{{ averange.toFixed(2) }}</span></span>
                  </div>

                  <a v-on:click="downloadActualListExcel(true, 'excel')" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span>
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  </a>

                  <div class="orderBy">
                    <label> Ordem por:
                      <select v-model="orderByValue">
                        <option value="">Selecione</option>
                        <option value="npsAverange">Média</option>
                        <option value="text">Status</option>
                      </select>
                    </label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> QTD. DIAS CADASTRADOS</th>
                        <th> TOTAL DE NPS RESPONDIDO</th>
                        <th> MÉDIA NPS</th>
                        <th> STATUS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="a in orderBy(dataNps, orderByValue)">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + a.companyId + '/' + a.contentSetting"
                               target="_blank" class="link">{{ a.companyName }}</a></td>
                        <td>{{ a.totalDaysCreated }}</td>
                        <td>{{ a.totalAnswered }}</td>
                        <td>{{ a.npsAverange }}</td>
                        <td>
                          <span v-if="a.text" v-bind:style="{'background': a.color}"
                                class="default-bg">{{ a.text }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <paginate v-if="totalPages > 1" v-model="pageNumber" :page-count="totalPages" :click-handler="searchNps"
                          :prev-text="'Anterior'" :next-text="'Próximo'" :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  REPORT_NPS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "analyze-nps",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      orderByValue: '',
      loading: false,
      failRequest: false,
      averange: '',
      dataNps: '',
      totalPromoters: null,
      totalNeutral: null,
      totalDefractors: null,
      pageNumber: 1,
      pageQtd: 20,
      totalPages: 0,
      dataSearch: {
        companyDesactived: '0',
        companyId: '',
        npsStage: '',
        lessThan: '',
        averangeUpTo: ''
      }
    }
  },
  methods: {
    downloadActualListExcel() {
      let bodyValue = [];
      this.dataNps.map((value, index) => {
        bodyValue.push([value.companyName, value.totalDaysCreated, value.totalAnswered, value.npsAverange, value.text]);

        if (index + 1 === this.dataNps.length) {
          let headValue = ["EMPRESA", "QTD. DIAS CADASTRADOS", "TOTAL DE NPS RESPONDIDO", "MÉDIA NPS", "STATUS"];

          window.downloadListExcel(headValue, bodyValue, "Média de NPS");
        }
      });
    },
    searchNps() {
      this.loading = true;

      let url = REPORT_NPS + "?t=kkkk";
      url += "&pageNumber=" + this.pageNumber + "&pageQtd=" + this.pageQtd;

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.npsStage)
        url += "&npsStage=" + this.dataSearch.npsStage;

      if (this.dataSearch.averangeUpTo)
        url += "&averangeUpTo=" + this.dataSearch.averangeUpTo;

      if (this.dataSearch.lessThan)
        url += "&lessThan=" + this.dataSearch.lessThan;

      if (this.dataSearch.companyDesactived === "1")
        url += "&companyDesactived=true";

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT REPORT_NPS:", response.data);

        this.averange = response.data.averange;
        this.dataNps = response.data.list;
        this.totalPromoters = response.data.totalPromoters;
        this.totalNeutral = response.data.totalNeutral;
        this.totalDefractors = response.data.totalDefractors;

        this.qtdTotal = response.data.count;
        this.totalPages = Math.ceil((response.data.count / this.pageQtd));

        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    downloadExcel(bool, type) {
      this.loading = true;

      let url = REPORT_NPS + "?t=kkkk";
      url += "&pageNumber=" + this.pageNumber + "&pageQtd=999999";
      url += "&isExcel=true";

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.npsStage)
        url += "&npsStage=" + this.dataSearch.npsStage;

      if (this.dataSearch.averangeUpTo)
        url += "&averangeUpTo=" + this.dataSearch.averangeUpTo;

      if (this.dataSearch.lessThan)
        url += "&lessThan=" + this.dataSearch.lessThan;

      if (this.dataSearch.companyDesactived === "1")
        url += "&companyDesactived=true";

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.getFile(url, true).then((data) => {
        UTIL_SERVICE.console("RESULT SEARCH USER:", data);

        let headers = data.headers;

        let filename = headers['x-filename'];
        let contentType = headers['content-type'];

        let linkElement = document.createElement('a');
        try {
          let blob = new Blob([data.data], {
            type: contentType
          });
          let url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", 'relatorio-analise-de-nps.csv');

          let clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      }).catch((reason) => {

        this.loading = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.searchNps();
  }
}
</script>

<style lang="scss">
.media-nps {
  display: block;
  margin-top: 20px;
  color: #3598dc !important;
  font-weight: bold;
  text-transform: uppercase;

  span {
    font-size: 22px;
  }
}

.default-bg {
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 4px !important;
  text-align: center;
  display: block;
  width: 100px;
}

.total-dnp {
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  display: block;

  span {
    display: block;
    font-size: 26px;
    margin-top: 5px;
    font-weight: 500;
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  margin-top: 0;
  border: none;
  font-weight: 700;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/nps/analyzeNps.vue